import React, { useContext, useState, useEffect, useRef } from 'react'
import Layout from '@/product/components/templates/Layout'
import CustomTable from '@/product/components/molecules/CustomTable'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import { Button } from '@mui/material'
import {
    mapData,
    converTime,
    getPickupHours,
} from '@/product/common/components'
import { useFormik } from 'formik'
import CustomCommonContext from '@/custom/context/common/commonContext'
import CustomDialog from '@/product/components/organisms/Dialog'
import CommonContext from '@/product/context/common/commonContext'
import * as Yup from 'yup'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SettingContext from '@/product/context/setting/settingContext'
import AlertContext from '@/product/context/alert/alertContext'
import UserCommonContext from '@/product/context/userCommon/commonContext'
import moment from 'moment'

const LocationManage = (props) => {
    const settingcontext = useContext(SettingContext)
    const usercommoncontext = useContext(UserCommonContext)
    const commonContext = useContext(CommonContext)
    const alertContext = useContext(AlertContext)

    const { setAlert } = alertContext

    const { USStates, allCountries, allStates, allCounties, getAllCounties } =
        commonContext

    const { allLocations, getGlobalVariable } = useContext(CustomCommonContext)
    const [isLoading, setIsLoading] = useState(true)

    const {
        searchTableFetch,
        searchTableAction,
        search_fetch_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseCommuncation,
    } = settingcontext

    const { getPreviousData, clearPreviousData, previous_data } =
        usercommoncontext
    const [parkingSlot, setParkingSlot] = useState([])
    const [changeStatus, setChangeStatus] = useState(false)
    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const data = props.data
    const toggleFullScreenPopup = props.function

    const [tableBody, setTableBody] = useState([])
    const formikSelection = useFormik({
        initialValues: {
            action: '',
            active: 0,
            id: 0,
            table: 'locations',
        },
        onSubmit: (values) => {
            const dataValue = values
            if (
                dataValue.action === 'active' ||
                dataValue.action === 'deactive' ||
                dataValue.action === 'delete'
            ) {
                dataValue.active =
                    dataValue.action === 'delete'
                        ? 2
                        : dataValue.action === 'active'
                        ? 1
                        : 0
                delete dataValue.action
                searchTableAction(values)
            }
        },
    })
    const validationArray = Yup.object({
        name: Yup.string().required('Required!'),
        address1: Yup.string().required('Required!'),
        city: Yup.string().required('Required!'),
        state: Yup.string().required('Required!'),
        zip: Yup.number().positive().integer().required('Required!'),
        // country: '',
        phone: Yup.string().required('Required!'),

        sunday_available: Yup.string().required('Required!'),

        sunday_starting: Yup.string().when('sunday_available', {
            is: (sunday_available) => {
                return sunday_available === 'open'
            },
            then: Yup.string()
                .required('Required!')
                .nullable()
                .typeError('Required!'),
        }),

        sunday_ending: Yup.string().when('sunday_available', {
            is: (sunday_available) => {
                return sunday_available === 'open'
            },
            then: Yup.string()
                .required('Required!')
                .nullable()
                .typeError('Required!'),
        }),

        sunday_break_start: Yup.string().when('sunday_available', {
            is: (sunday_available) => {
                return sunday_available === 'open'
            },
            then: Yup.string()
                .required('Required!')
                .nullable()
                .typeError('Required!'),
        }),
        sunday_break_end: Yup.string().when('sunday_available', {
            is: (sunday_available) => {
                return sunday_available === 'open'
            },
            then: Yup.string()
                .required('Required!')
                .nullable()
                .typeError('Required!'),
        }),

        monday_starting: Yup.string().when('monday_available', {
            is: (monday_available) => {
                return monday_available === 'open'
            },
            then: Yup.string()
                .required('Required!')
                .nullable()
                .typeError('Required!'),
        }),

        monday_ending: Yup.string().when('monday_available', {
            is: (monday_available) => {
                return monday_available === 'open'
            },
            then: Yup.string()
                .required('Required!')
                .nullable()
                .typeError('Required!'),
        }),

        monday_break_start: Yup.string().when('monday_available', {
            is: (monday_available) => {
                return monday_available === 'open'
            },
            then: Yup.string()
                .required('Required!')
                .nullable()
                .typeError('Required!'),
        }),
        monday_break_end: Yup.string().when('monday_available', {
            is: (monday_available) => {
                return monday_available === 'open'
            },
            then: Yup.string()
                .required('Required!')
                .nullable()
                .typeError('Required!'),
        }),

        tuesday_starting: Yup.string().when('tuesday_available', {
            is: (tuesday_available) => {
                return tuesday_available === 'open'
            },
            then: Yup.string()
                .required('Required!')
                .nullable()
                .typeError('Required!'),
        }),

        tuesday_ending: Yup.string().when('tuesday_available', {
            is: (tuesday_available) => {
                return tuesday_available === 'open'
            },
            then: Yup.string()
                .required('Required!')
                .nullable()
                .typeError('Required!'),
        }),

        tuesday_break_start: Yup.string().when('tuesday_available', {
            is: (tuesday_available) => {
                return tuesday_available === 'open'
            },
            then: Yup.string()
                .required('Required!')
                .nullable()
                .typeError('Required!'),
        }),
        tuesday_break_end: Yup.string().when('tuesday_available', {
            is: (tuesday_available) => {
                return tuesday_available === 'open'
            },
            then: Yup.string()
                .required('Required!')
                .nullable()
                .typeError('Required!'),
        }),

        wednesday_starting: Yup.string().when('wednesday_available', {
            is: (wednesday_available) => {
                return wednesday_available === 'open'
            },
            then: Yup.string()
                .required('Required!')
                .nullable()
                .typeError('Required!'),
        }),

        wednesday_ending: Yup.string().when('wednesday_available', {
            is: (wednesday_available) => {
                return wednesday_available === 'open'
            },
            then: Yup.string()
                .required('Required!')
                .nullable()
                .typeError('Required!'),
        }),

        wednesday_break_start: Yup.string().when('wednesday_available', {
            is: (wednesday_available) => {
                return wednesday_available === 'open'
            },
            then: Yup.string()
                .required('Required!')
                .nullable()
                .typeError('Required!'),
        }),
        wednesday_break_end: Yup.string().when('wednesday_available', {
            is: (wednesday_available) => {
                return wednesday_available === 'open'
            },
            then: Yup.string()
                .required('Required!')
                .nullable()
                .typeError('Required!'),
        }),

        thursday_starting: Yup.string().when('thursday_available', {
            is: (thursday_available) => {
                return thursday_available === 'open'
            },
            then: Yup.string()
                .required('Required!')
                .nullable()
                .typeError('Required!'),
        }),

        thursday_ending: Yup.string().when('thursday_available', {
            is: (thursday_available) => {
                return thursday_available === 'open'
            },
            then: Yup.string()
                .required('Required!')
                .nullable()
                .typeError('Required!'),
        }),

        thursday_break_start: Yup.string().when('thursday_available', {
            is: (thursday_available) => {
                return thursday_available === 'open'
            },
            then: Yup.string()
                .required('Required!')
                .nullable()
                .typeError('Required!'),
        }),
        thursday_break_end: Yup.string().when('thursday_available', {
            is: (thursday_available) => {
                return thursday_available === 'open'
            },
            then: Yup.string()
                .required('Required!')
                .nullable()
                .typeError('Required!'),
        }),

        friday_starting: Yup.string().when('friday_available', {
            is: (friday_available) => {
                return friday_available === 'open'
            },
            then: Yup.string()
                .required('Required!')
                .nullable()
                .typeError('Required!'),
        }),

        friday_ending: Yup.string().when('friday_available', {
            is: (friday_available) => {
                return friday_available === 'open'
            },
            then: Yup.string()
                .required('Required!')
                .nullable()
                .typeError('Required!'),
        }),

        friday_break_start: Yup.string().when('friday_available', {
            is: (friday_available) => {
                return friday_available === 'open'
            },
            then: Yup.string()
                .required('Required!')
                .nullable()
                .typeError('Required!'),
        }),
        friday_break_end: Yup.string().when('friday_available', {
            is: (friday_available) => {
                return friday_available === 'open'
            },
            then: Yup.string()
                .required('Required!')
                .nullable()
                .typeError('Required!'),
        }),

        saturday_starting: Yup.string().when('saturday_available', {
            is: (saturday_available) => {
                return saturday_available === 'open'
            },
            then: Yup.string()
                .required('Required!')
                .nullable()
                .typeError('Required!'),
        }),

        saturday_ending: Yup.string().when('saturday_available', {
            is: (saturday_available) => {
                return saturday_available === 'open'
            },
            then: Yup.string()
                .required('Required!')
                .nullable()
                .typeError('Required!'),
        }),

        saturday_break_start: Yup.string().when('saturday_available', {
            is: (saturday_available) => {
                return saturday_available === 'open'
            },
            then: Yup.string()
                .required('Required!')
                .nullable()
                .typeError('Required!'),
        }),
        saturday_break_end: Yup.string().when('saturday_available', {
            is: (saturday_available) => {
                return saturday_available === 'open'
            },
            then: Yup.string()
                .required('Required!')
                .nullable()
                .typeError('Required!'),
        }),

        // monday_available: 'closed',
        // monday_starting: '',
        // monday_ending: '',
        // monday_break_start: '',
        // monday_break_end: '',

        // tuesday_available: 'closed',
        // tuesday_starting: '',
        // tuesday_ending: '',
        // tuesday_break_start: '',
        // tuesday_break_end: '',

        // wednesday_available: 'closed',
        // wednesday_starting: '',
        // wednesday_ending: '',
        // wednesday_break_start: '',
        // wednesday_break_end: '',

        // thursday_available: 'closed',
        // thursday_starting: '',
        // thursday_ending: '',
        // thursday_break_start: '',
        // thursday_break_end: '',

        // friday_available: 'closed',
        // friday_starting: '',
        // friday_ending: '',
        // friday_break_start: '',
        // friday_break_end: '',

        // saturday_available: 'closed',
        // saturday_starting: '',
        // saturday_ending: '',
        // saturday_break_start: '',
        // saturday_break_end: '',

        // full_address: '',
        // place_id: '',
        // latitude: '',
        // longitude: '',
    })

    const formikView = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            primaryTable: 'locations',
            filters: true,
            filters: {
                name: {
                    value: '',
                    type: 'like',
                    field: 'l.name',
                },
            },
        },
        onSubmit: (values) => {
            searchTableFetch(values, 'location')
        },
    })

    let timeFormatArray = [
        'sunday_starting',
        'sunday_ending',
        'sunday_break_start',
        'sunday_break_end',

        'monday_starting',
        'monday_ending',
        'monday_break_start',
        'monday_break_end',

        'tuesday_starting',
        'tuesday_ending',
        'tuesday_break_start',
        'tuesday_break_end',

        'wednesday_starting',
        'wednesday_ending',
        'wednesday_break_start',
        'wednesday_break_end',

        'thursday_starting',
        'thursday_ending',
        'thursday_break_start',
        'thursday_break_end',

        'friday_starting',
        'friday_ending',
        'friday_break_start',
        'friday_break_end',

        'saturday_starting',
        'saturday_ending',
        'saturday_break_start',
        'saturday_break_end',
    ]

    const formik = useFormik({
        initialValues: {
            id: 0,
            name: '',
            address1: '',
            city: '',
            state: '',
            zip: '',
            country: global.defaultCountry || '',
            phone: '',

            sunday_available: 'open',
            sunday_starting: '',
            sunday_ending: '',
            sunday_break_start: '',
            sunday_break_end: '',

            monday_available: 'open',
            monday_starting: '',
            monday_ending: '',
            monday_break_start: '',
            monday_break_end: '',

            tuesday_available: 'open',
            tuesday_starting: '',
            tuesday_ending: '',
            tuesday_break_start: '',
            tuesday_break_end: '',

            wednesday_available: 'open',
            wednesday_starting: '',
            wednesday_ending: '',
            wednesday_break_start: '',
            wednesday_break_end: '',

            thursday_available: 'open',
            thursday_starting: '',
            thursday_ending: '',
            thursday_break_start: '',
            thursday_break_end: '',

            friday_available: 'open',
            friday_starting: '',
            friday_ending: '',
            friday_break_start: '',
            friday_break_end: '',

            saturday_available: 'open',
            saturday_starting: '',
            saturday_ending: '',
            saturday_break_start: '',
            saturday_break_end: '',

            table: 'locations',
            active: 1,
            full_address: '',
            place_id: '',
            latitude: '',
            longitude: '',
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            let value = values

            timeFormatArray.map((name) => {
                if (name && value[name]) {
                    value[name] = moment(value[name], 'h:mm a').format(
                        'HH:mm:ss'
                    )
                }

                return true
            })
            values.parking_slot = parkingSlot
            console.log('+++++++++++++', values)
            searchTableAction(value)
        },
    })

    console.log('formik errors', formik.touched, formik.errors)

    useEffect(() => {
        if (search_fetch_data) {
            if (search_fetch_data.from === 'location') {
                setTableBody(
                    search_fetch_data.records.length
                        ? search_fetch_data.records
                        : []
                )
            }
        }
    }, [search_fetch_data])

    useEffect(() => {
        searchTableFetch(formikView.values, 'location')
    }, [])

    useEffect(() => {
        if (responseStatusSetting) {
            if (
                responseStatusSetting.from === 'CommunicationSearchTable' &&
                responseStatusSetting.status === 'success'
            ) {
                setChangeStatus(false)
                toggleFullScreenPopup(false)
                formik.resetForm()
            }
        }
    }, [responseStatusSetting])

    const onClickEdit = (id, secondaryID, type) => {
        toggleFullScreenPopup(true, 'edit', id)
    }

    useEffect(() => {
        if (data.status === 'edit') {
            formik.setFieldValue('id', data.id)
            const template = allLocations.filter((cat) => cat.id === data.id)

            timeFormatArray.map((name) => {
                if (template[0][name]) {
                    template[0][name] = moment(
                        template[0][name],
                        'HH:mm:ss'
                    ).format('h:mm a')
                } else {
                    template[0][name] = ''
                }
                return true
            })

            formik.setValues({
                ...formik.values,
                ...template[0],
            })
        } else {
            resetFrom()
        }
    }, [data])

    const resetFrom = () => {
        formik.setValues({
            id: 0,
            name: '',
            address1: '',
            city: '',
            state: '',
            zip: '',
            country: global.defaultCountry || '',
            phone: '',

            sunday_available: 'open',
            sunday_starting: '',
            sunday_ending: '',
            sunday_break_start: '',
            sunday_break_end: '',

            monday_available: 'open',
            monday_starting: '',
            monday_ending: '',
            monday_break_start: '',
            monday_break_end: '',

            tuesday_available: 'open',
            tuesday_starting: '',
            tuesday_ending: '',
            tuesday_break_start: '',
            tuesday_break_end: '',

            wednesday_available: 'open',
            wednesday_starting: '',
            wednesday_ending: '',
            wednesday_break_start: '',
            wednesday_break_end: '',

            thursday_available: 'open',
            thursday_starting: '',
            thursday_ending: '',
            thursday_break_start: '',
            thursday_break_end: '',

            friday_available: 'open',
            friday_starting: '',
            friday_ending: '',
            friday_break_start: '',
            friday_break_end: '',

            saturday_available: 'open',
            saturday_starting: '',
            saturday_ending: '',
            saturday_break_start: '',
            saturday_break_end: '',

            table: 'locations',
            active: 1,
            full_address: '',
            place_id: '',
            latitude: '',
            longitude: '',
        })
    }

    const tableValues = [
        {
            field: 'id',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'ID',
            filterable: true,
            filterField: 'id',
        },
        {
            field: 'name',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Name *',
            filterable: true,
            filterField: 'name',
        },
        {
            field: 'active',
            condition: true,
            conditionValue: {
                formula: {
                    key1: 'active',
                    key2: 1,
                    notation: '===',
                },
                true: {
                    type: 'text',
                    value: 'Active',
                },
                false: {
                    type: 'text',
                    value: 'Deactive',
                },
            },
            type: 'text',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Status',
        },
        {
            field: 'action',
            type: 'button',
            clickType: 'edit',
            onclick: onClickEdit,
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Action',
            tooltipTitle: 'Edit location',
        },
    ]
    const details = {
        formik: formik,
        data: [
            {
                label: 'Active',
                placeholder: 'Make Active',
                type: 'switch',
                class: 'col-12',
                name: 'active',
            },
            {
                label: 'Business Name *',
                placeholder: 'Enter the Location Name',
                type: 'textarea',
                class: 'col-6',
                name: 'name',
            },
            {
                label: 'Business Phone *',
                placeholder: 'Enter the Location Phone',
                type: 'phone',
                class: 'col-6',
                name: 'phone',
            },
            // {
            //     label: 'Country',
            //     type: 'select',
            //     placeholder: 'Select a Country',
            //     class: 'col-sm-6 col-12',
            //     disabled: true,
            //     options: allCountries
            //         .filter(
            //             (country) =>
            //                 global.ignoreCountry.indexOf(country.isoCode) === -1
            //         )
            //         .map((country) => {
            //             let busCategoryChanged = {}
            //             busCategoryChanged.show = country.name
            //             busCategoryChanged.value = country.isoCode
            //             return busCategoryChanged
            //         }),
            //     name: 'country',
            // },
            {
                label: 'Address *',
                placeholder: 'Enter the Address',
                type: 'google_place_autocomplete',
                // type: '',
                defaultCountry: 'US',
                class: 'col-12',
                name: 'address1',
                placeID: true,
                fullAddress: true,
            },
            {
                label: 'State *',
                placeholder: 'Enter the State',
                type: 'input',
                class: 'col-4',
                name: 'state',
            },
            {
                label: 'City *',
                placeholder: 'Enter the City',
                type: 'input',
                class: 'col-4',
                name: 'city',
            },
            {
                label: 'Zip *',
                placeholder: 'Enter the Zip',
                type: 'input',
                class: 'col-4',
                name: 'zip',
            },
            {
                type: 'misc',
                content: 'Preparation time',
                class: 'col-12',
            },
            {
                label: 'Hours',
                placeholder: 'Enter the hours',
                type: 'number',
                class: 'col-2',
                name: 'prep_time_hours',
            },
            {
                label: 'Minutes',
                placeholder: 'Enter the minutes',
                type: 'number',
                class: 'col-2',
                name: 'prep_time_minutes',
            },
            {
                type: 'misc',
                content: 'Pick up hours',
                class: 'col-12',
            },

            {
                type: 'misc',
                content: 'Monday',
                class: 'col-2',
            },
            {
                label: '',
                placeholder: '',
                class: 'col-2',
                name: 'monday_available',
                type: 'select',
                options: [
                    {
                        show: 'Open',
                        value: 'open',
                    },
                    {
                        show: 'Closed',
                        value: 'closed',
                    },

                    {
                        show: 'All Day',
                        value: 'all_day',
                    },
                ],
                defaultOptionValue: '',
            },
            {
                label: 'Start Time',
                placeholder: 'Select Start Time',
                type: 'time',
                class: `${
                    formik.values.monday_available === 'open'
                        ? 'col-2'
                        : 'd-none col-2'
                } `,
                name: 'monday_starting',
            },
            {
                label: 'End Time',
                placeholder: 'Select End Time',
                type: 'time',
                class: `${
                    formik.values.monday_available === 'open'
                        ? 'col-2'
                        : 'd-none col-2'
                } `,
                name: 'monday_ending',
            },
            {
                label: 'Break Start Time',
                placeholder: 'Select Break Start Time',
                type: 'time',
                class: `${
                    formik.values.monday_available === 'open' ||
                    formik.values.monday_available === 'all_day'
                        ? 'col-2'
                        : 'd-none col-2'
                } `,
                name: 'monday_break_start',
            },
            {
                label: 'Break End Time',
                placeholder: 'Select Break End Time',
                type: 'time',
                class: `${
                    formik.values.monday_available === 'open' ||
                    formik.values.monday_available === 'all_day'
                        ? 'col-2'
                        : 'd-none col-2'
                } `,
                name: 'monday_break_end',
            },
            {
                type: 'misc',
                content: 'Tuesday',
                class: 'col-2',
            },
            {
                label: '',
                placeholder: '',
                class: 'col-2',
                name: 'tuesday_available',
                type: 'select',
                options: [
                    {
                        show: 'Open',
                        value: 'open',
                    },
                    {
                        show: 'Closed',
                        value: 'closed',
                    },

                    {
                        show: 'All Day',
                        value: 'all_day',
                    },
                ],
                defaultOptionValue: '',
            },
            {
                label: 'Start Time',
                placeholder: 'Select Start Time',
                type: 'time',
                class: `${
                    formik.values.tuesday_available === 'open'
                        ? 'col-2'
                        : 'd-none col-2'
                } `,
                name: 'tuesday_starting',
            },
            {
                label: 'End Time',
                placeholder: 'Select End Time',
                type: 'time',
                class: `${
                    formik.values.tuesday_available === 'open'
                        ? 'col-2'
                        : 'd-none col-2'
                } `,
                name: 'tuesday_ending',
            },
            {
                label: 'Break Start Time',
                placeholder: 'Select Break Start Time',
                type: 'time',
                class: `${
                    formik.values.tuesday_available === 'open' ||
                    formik.values.tuesday_available === 'all_day'
                        ? 'col-2'
                        : 'd-none col-2'
                } `,
                name: 'tuesday_break_start',
            },
            {
                label: 'Break End Time',
                placeholder: 'Select Break End Time',
                type: 'time',
                class: `${
                    formik.values.tuesday_available === 'open' ||
                    formik.values.tuesday_available === 'all_day'
                        ? 'col-2'
                        : 'd-none col-2'
                } `,
                name: 'tuesday_break_end',
            },
            {
                type: 'misc',
                content: 'Wednesday',
                class: 'col-2',
            },
            {
                label: '',
                placeholder: '',
                class: 'col-2',
                name: 'wednesday_available',
                type: 'select',
                options: [
                    {
                        show: 'Open',
                        value: 'open',
                    },
                    {
                        show: 'Closed',
                        value: 'closed',
                    },

                    {
                        show: 'All Day',
                        value: 'all_day',
                    },
                ],
                defaultOptionValue: '',
            },
            {
                label: 'Start Time',
                placeholder: 'Select Start Time',
                type: 'time',
                class: `${
                    formik.values.wednesday_available === 'open'
                        ? 'col-2'
                        : 'd-none col-2'
                } `,
                name: 'wednesday_starting',
            },
            {
                label: 'End Time',
                placeholder: 'Select End Time',
                type: 'time',
                class: `${
                    formik.values.wednesday_available === 'open'
                        ? 'col-2'
                        : 'd-none col-2'
                } `,
                name: 'wednesday_ending',
            },
            {
                label: 'Break Start Time',
                placeholder: 'Select Break Start Time',
                type: 'time',
                class: `${
                    formik.values.wednesday_available === 'open' ||
                    formik.values.wednesday_available === 'all_day'
                        ? 'col-2'
                        : 'd-none col-2'
                } `,
                name: 'wednesday_break_start',
            },
            {
                label: 'Break End Time',
                placeholder: 'Select Break End Time',
                type: 'time',
                class: `${
                    formik.values.wednesday_available === 'open' ||
                    formik.values.wednesday_available === 'all_day'
                        ? 'col-2'
                        : 'd-none col-2'
                } `,
                name: 'wednesday_break_end',
            },
            {
                type: 'misc',
                content: 'Thursday',
                class: 'col-2',
            },
            {
                label: '',
                placeholder: '',
                class: 'col-2',
                name: 'thursday_available',
                type: 'select',
                options: [
                    {
                        show: 'Open',
                        value: 'open',
                    },
                    {
                        show: 'Closed',
                        value: 'closed',
                    },

                    {
                        show: 'All Day',
                        value: 'all_day',
                    },
                ],
                defaultOptionValue: '',
            },
            {
                label: 'Start Time',
                placeholder: 'Select Start Time',
                type: 'time',
                class: `${
                    formik.values.thursday_available === 'open'
                        ? 'col-2'
                        : 'd-none col-2'
                } `,
                name: 'thursday_starting',
            },
            {
                label: 'End Time',
                placeholder: 'Select End Time',
                type: 'time',
                class: `${
                    formik.values.thursday_available === 'open'
                        ? 'col-2'
                        : 'd-none col-2'
                } `,
                name: 'thursday_ending',
            },
            {
                label: 'Break Start Time',
                placeholder: 'Select Break Start Time',
                type: 'time',
                class: `${
                    formik.values.thursday_available === 'open' ||
                    formik.values.thursday_available === 'all_day'
                        ? 'col-2'
                        : 'd-none col-2'
                } `,
                name: 'thursday_break_start',
            },
            {
                label: 'Break End Time',
                placeholder: 'Select Break End Time',
                type: 'time',
                class: `${
                    formik.values.thursday_available === 'open' ||
                    formik.values.thursday_available === 'all_day'
                        ? 'col-2'
                        : 'd-none col-2'
                } `,
                name: 'thursday_break_end',
            },

            {
                type: 'misc',
                content: 'Friday',
                class: 'col-2',
            },
            {
                label: '',
                placeholder: '',
                class: 'col-2',
                name: 'friday_available',
                type: 'select',
                options: [
                    {
                        show: 'Open',
                        value: 'open',
                    },
                    {
                        show: 'Closed',
                        value: 'closed',
                    },

                    {
                        show: 'All Day',
                        value: 'all_day',
                    },
                ],
                defaultOptionValue: '',
            },
            {
                label: 'Start Time',
                placeholder: 'Select Start Time',
                type: 'time',
                class: `${
                    formik.values.friday_available === 'open'
                        ? 'col-2'
                        : 'd-none col-2'
                } `,
                name: 'friday_starting',
            },
            {
                label: 'End Time',
                placeholder: 'Select End Time',
                type: 'time',
                class: `${
                    formik.values.friday_available === 'open'
                        ? 'col-2'
                        : 'd-none col-2'
                } `,
                name: 'friday_ending',
            },
            {
                label: 'Break Start Time',
                placeholder: 'Select Break Start Time',
                type: 'time',
                class: `${
                    formik.values.friday_available === 'open' ||
                    formik.values.friday_available === 'all_day'
                        ? 'col-2'
                        : 'd-none col-2'
                } `,
                name: 'friday_break_start',
            },
            {
                label: 'Break End Time',
                placeholder: 'Select Break End Time',
                type: 'time',
                class: `${
                    formik.values.friday_available === 'open' ||
                    formik.values.friday_available === 'all_day'
                        ? 'col-2'
                        : 'd-none col-2'
                } `,
                name: 'friday_break_end',
            },
            {
                type: 'misc',
                content: 'Saturday',
                class: 'col-2',
            },
            {
                label: '',
                placeholder: '',
                class: 'col-2',
                name: 'saturday_available',
                type: 'select',
                options: [
                    {
                        show: 'Open',
                        value: 'open',
                    },
                    {
                        show: 'Closed',
                        value: 'closed',
                    },

                    {
                        show: 'All Day',
                        value: 'all_day',
                    },
                ],
                defaultOptionValue: '',
            },
            {
                label: 'Start Time',
                placeholder: 'Select Start Time',
                type: 'time',
                class: `${
                    formik.values.saturday_available === 'open'
                        ? 'col-2'
                        : 'd-none col-2'
                } `,
                name: 'saturday_starting',
            },
            {
                label: 'End Time',
                placeholder: 'Select End Time',
                type: 'time',
                class: `${
                    formik.values.saturday_available === 'open'
                        ? 'col-2'
                        : 'd-none col-2'
                } `,
                name: 'saturday_ending',
            },
            {
                label: 'Break Start Time',
                placeholder: 'Select Break Start Time',
                type: 'time',
                class: `${
                    formik.values.saturday_available === 'open' ||
                    formik.values.saturday_available === 'all_day'
                        ? 'col-2'
                        : 'd-none col-2'
                } `,
                name: 'saturday_break_start',
            },
            {
                label: 'Break End Time',
                placeholder: 'Select Break End Time',
                type: 'time',
                class: `${
                    formik.values.saturday_available === 'open' ||
                    formik.values.saturday_available === 'all_day'
                        ? 'col-2'
                        : 'd-none col-2'
                } `,
                name: 'saturday_break_end',
            },
            {
                type: 'misc',
                content: 'Sunday',
                class: 'col-2',
            },
            {
                label: '',
                placeholder: '',
                class: 'col-2',
                name: 'sunday_available',
                type: 'select',
                options: [
                    {
                        show: 'Open',
                        value: 'open',
                    },
                    {
                        show: 'Closed',
                        value: 'closed',
                    },

                    {
                        show: 'All Day',
                        value: 'all_day',
                    },
                ],
                defaultOptionValue: '',
            },
            {
                label: 'Start Time',
                placeholder: 'Select Start Time',
                type: 'time',
                class: `${
                    formik.values.sunday_available === 'open'
                        ? 'col-2'
                        : 'd-none col-2'
                } `,
                name: 'sunday_starting',
            },
            {
                label: 'End Time',
                placeholder: 'Select End Time',
                type: 'time',
                class: `${
                    formik.values.sunday_available === 'open'
                        ? 'col-2'
                        : 'd-none col-2'
                } `,
                name: 'sunday_ending',
            },
            {
                label: 'Break Start Time',
                placeholder: 'Select Break Start Time',
                type: 'time',
                class: `${
                    formik.values.sunday_available === 'open' ||
                    formik.values.sunday_available === 'all_day'
                        ? 'col-2'
                        : 'd-none col-2'
                } `,
                name: 'sunday_break_start',
            },
            {
                label: 'Break End Time',
                placeholder: 'Select Break End Time',
                type: 'time',
                class: `${
                    formik.values.sunday_available === 'open' ||
                    formik.values.sunday_available === 'all_day'
                        ? 'col-2'
                        : 'd-none col-2'
                } `,
                name: 'sunday_break_end',
            },
            {
                label: 'Slot frequency (Minutes)',
                placeholder: '',
                type: 'number',
                class: 'col-6',
                name: 'slot_minutes',
            },
            {
                label: 'Maximum orders per slot (0 is unlimited)',
                placeholder: '',
                type: 'number',
                class: 'col-6',
                name: 'slot_per_limit',
            },
            {
                label: 'Time Cut Off',
                placeholder: 'Select Cut Off Time',
                type: 'time',
                class: 'col-6',
                name: 'cut_off_time',
            },
            {
                label: 'Maximum days to collect',
                placeholder: 'Select Cut Off Time',
                type: 'number',
                class: 'col-6',
                name: 'max_days_limit',
            },
        ],
    }

    const onSelectMultiProducts = (data, action) => {
        formikSelection.values.action = action
        formikSelection.values.id = data
        if (
            action === 'active' ||
            action === 'deactive' ||
            action === 'delete'
        ) {
            if (action === 'delete') {
                getPreviousData({
                    page: 1,
                    limit: 20,
                    order: '',
                    orderby: '',
                    primaryTable: 'projects',
                    customTable: 'custom_projects',
                    similars: {
                        category: {
                            value: formikSelection.values.id,
                            type: 'arrayin',
                            field: 'p.location_id',
                        },
                    },
                })
            } else if (action === 'deactive') {
                setChangeStatus(true)
            } else {
                setChangeStatus(true)
            }
        }
    }

    useEffect(() => {
        if (previous_data) {
            if (previous_data.records.length) {
                setAlert('Previous records exists!', 'error')
                formikSelection.values.action = ''
                formikSelection.values.id = 0
                clearPreviousData()
            } else if (formikSelection.values.action) {
                setChangeStatus(true)
            }
        }
    }, [previous_data])

    const tableActions = []
    tableActions.push(
        {
            label: 'Move to Active',
            icon: <span className="material-icons">check_circle</span>,
            onclick: onSelectMultiProducts,
            type: 'active',
        },
        {
            label: 'Move to Deactive',
            icon: <span className="material-icons">block</span>,
            onclick: onSelectMultiProducts,
            type: 'deactive',
        },
        {
            label: 'Delete Permanently',
            icon: <span className="material-icons">cancel</span>,
            onclick: onSelectMultiProducts,
            type: 'delete',
        }
    )

    const searchInfo = [
        {
            label: 'Business location ',
            placeholder: 'Enter location',
            class: 'col-md-4 col-sm-6 col-12',
            type: 'text',
            name: 'name',
            filter: true,
            formik: formikView,
        },
    ]
    const parkingSlotDetail = [
        {
            label: 'Parking Spots',
            placeholder: 'Sel',
            type: '',
            class: 'col-6',
            name: 'parking_slot',
            formik: formik,
        },
    ]
    const addParkingSlot = () => {
        setParkingSlot((ele) => [...ele, formik.values.parking_slot])
        formik.values.parking_slot = ''
    }
    const removeParkingSlot = (index) => {
        setParkingSlot((ele) => ele.filter((data, num) => num !== index))
    }
    const submitFunction = () => {
        formik.handleSubmit()
        //toggleFullScreenPopup(false)
    }
    return (
        <FullScreenPopup
            modaltitle={
                data.status === 'new' ? 'Add New Location' : 'Edit Location'
            }
            open={data.popup}
            handleClose={() => {
                toggleFullScreenPopup(false, 'new', 0)
                formik.resetForm()
            }}
        >
            <div className="dashboard addNewListing mt-4">
                <div className="fspBody">
                    {/* <form
                            onSubmit={formik.handleSubmit}
                            autoComplete="nofill"
                        > */}
                    <div className="row">{mapData(details)}</div>
                    <div className="fspBody">
                        <div className="row">
                            {mapData(parkingSlotDetail)}
                            <div className="actionButton d-flex justify-content-center align-items-center">
                                <PrimaryButton
                                    id="location_submit"
                                    type="submit"
                                    label="Add parking slot"
                                    onClick={addParkingSlot}
                                />
                            </div>
                        </div>
                        <div className="row d-flex ">
                            {parkingSlot.map((ele, index) => {
                                return (
                                    <>
                                        {' '}
                                        <SecondaryButton
                                            id="location_cancel"
                                            label={ele}
                                            onClick={() =>
                                                removeParkingSlot(index)
                                            }
                                        />
                                    </>
                                )
                            })}
                        </div>
                    </div>
                    <div className="actionButton d-flex justify-content-center align-items-center">
                        <SecondaryButton
                            id="location_cancel"
                            label="Cancel"
                            onClick={() => {
                                toggleFullScreenPopup(false)
                                formik.resetForm()
                            }}
                        />
                        <PrimaryButton
                            id="location_submit"
                            label="Submit"
                            onClick={submitFunction}
                        />
                    </div>
                    {/* </form> */}
                </div>
            </div>
        </FullScreenPopup>
    )
}
export default LocationManage
